import axios from 'axios'

const adapter = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
})

export default adapter
